/* JD slajder v3 – beskonačan slajder za sve JD sekcije (hero, brendovi, proizvodi).
   - Pomera se preko CSS transform-a (ne preko nativnog skrola), pa prelaz
     poslednji → prvi i prvi → poslednji više nikad ne zaključava slajder.
   - Strelice i swipe rade odmah, i dok animacija još traje.
   - Opciono: autoplay (pauza na hover), tačkice, blagi fade aktivnog slajda.
   - Broj vidljivih: data-pv-m (mobilni), data-pv-t (tablet), data-pv-d (desktop). */
(function () {
  'use strict';
  if (window.__jdSliderV3) return;
  window.__jdSliderV3 = true;

  var mqTablet = window.matchMedia('(min-width: 750px)');
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DURATION = 550;
  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var sliders = [];

  function toArray(list) { return Array.prototype.slice.call(list); }

  function Slider(root) {
    var self = this;
    this.root = root;
    this.track = root.querySelector('.jd-slider__track');
    if (!this.track) return;

    this.prevBtn = root.querySelector('.jd-slider__btn--prev');
    this.nextBtn = root.querySelector('.jd-slider__btn--next');
    this.dotsWrap = root.querySelector('[data-jd-dots]');
    this.originals = toArray(this.track.children);
    this.n = this.originals.length;
    this.fade = root.hasAttribute('data-jd-fade');
    this.autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

    this.pv = 1;
    this.pos = 0;
    this.x = 0;
    this.step = 0;
    this.loop = false;
    this.active = -1;
    this.drag = null;
    this.hover = false;
    this.lastUser = 0;
    this.settleTimer = null;
    this.suppressClick = false;
    this.width = 0;

    this.originals.forEach(function (el, i) { el.setAttribute('data-jd-i', i); });

    /* Omotač koji seče sadržaj; staza se pomera unutar njega */
    var vp = document.createElement('div');
    vp.className = 'jd-slider__viewport';
    this.track.parentNode.insertBefore(vp, this.track);
    vp.appendChild(this.track);
    this.viewport = vp;
    vp.addEventListener('scroll', function () { if (vp.scrollLeft) vp.scrollLeft = 0; }, { passive: true });

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.user(); self.go(-1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.user(); self.go(1); });

    this.track.addEventListener('transitionend', function (e) {
      if (e.target === self.track && e.propertyName === 'transform') self.settle();
    });

    this.bindDrag();
    this.bindFocus();

    /* Promena širine bez resize događaja (npr. pojava skrol-trake) */
    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(function () {
        if (!self.step || Math.abs(self.viewport.clientWidth - self.width) < 1) return;
        if (self.pvNow() !== self.pv) { self.build(); return; }
        self.measure();
        self.setX(-self.pos * self.step, false);
      });
      this.ro.observe(vp);
    }
    this.buildDots();
    this.build();
    this.startAutoplay();
    root.classList.add('jd-slider--ready');
  }

  /* ---------- Merenje i pozicija ---------- */

  Slider.prototype.pvNow = function () {
    var r = this.root;
    var v;
    if (mqDesktop.matches) v = r.getAttribute('data-pv-d');
    else if (mqTablet.matches) v = r.getAttribute('data-pv-t') || r.getAttribute('data-pv-d');
    else v = r.getAttribute('data-pv-m');
    return parseInt(v, 10) || 1;
  };

  Slider.prototype.measure = function () {
    var k = this.track.children;
    if (k.length > 1) {
      this.step = k[1].getBoundingClientRect().left - k[0].getBoundingClientRect().left;
    } else {
      this.step = this.viewport.clientWidth;
    }
    if (!this.step) this.step = this.viewport.clientWidth || 1;
    this.width = this.viewport.clientWidth;
  };

  Slider.prototype.maxPos = function () {
    return this.loop ? this.n + this.pv : Math.max(0, this.n - this.pv);
  };

  Slider.prototype.setX = function (x, animate) {
    this.x = x;
    var t = this.track;
    t.style.transition = animate && !reduceMQ.matches ? 'transform ' + DURATION + 'ms ' + EASE : 'none';
    t.style.transform = 'translate3d(' + x + 'px, 0, 0)';
  };

  Slider.prototype.currentX = function () {
    var tr = window.getComputedStyle(this.track).transform;
    if (!tr || tr === 'none') return 0;
    var m = tr.match(/matrix(3d)?\(([^)]+)\)/);
    if (!m) return this.x;
    var v = m[2].split(',').map(parseFloat);
    return m[1] ? v[12] : v[4];
  };

  Slider.prototype.setPos = function (p, animate) {
    var self = this;
    p = Math.max(0, Math.min(this.maxPos(), p));
    this.pos = p;
    clearTimeout(this.settleTimer);
    this.setX(-p * this.step, animate);
    this.sync();
    if (animate && !reduceMQ.matches) {
      this.settleTimer = setTimeout(function () { self.settle(); }, DURATION + 80);
    } else {
      this.settle();
    }
  };

  /* Ako smo na klonu, neprimetno prebaci na isti (originalni) slajd.
     Radi i usred animacije: vizuelni položaj se ne menja. */
  Slider.prototype.normalize = function () {
    if (!this.loop) return;
    var shift = 0;
    if (this.pos < this.pv) shift = this.n;
    else if (this.pos >= this.pv + this.n) shift = -this.n;
    if (!shift) return;
    var cur = this.currentX();
    this.pos += shift;
    this.setX(cur - shift * this.step, false);
    void this.track.offsetWidth;
  };

  Slider.prototype.settle = function () {
    clearTimeout(this.settleTimer);
    if (this.drag && this.drag.axis === 'x') return;
    this.normalize();
    if (this.loop && this.pos >= this.pv && this.pos < this.pv + this.n) {
      this.setX(-this.pos * this.step, false);
    }
  };

  /* ---------- Gradnja (klonovi na oba kraja) ---------- */

  Slider.prototype.build = function () {
    var t = this.track;
    var old = t.querySelectorAll('[data-jd-clone]');
    for (var i = 0; i < old.length; i++) t.removeChild(old[i]);

    var keep = this.active >= 0 ? this.active : 0;
    this.pv = this.pvNow();
    this.loop = this.n > this.pv;
    this.root.classList.toggle('jd-slider--static', !this.loop);

    if (this.loop) {
      var pv = this.pv;
      var first = this.originals[0];
      var makeClone = function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('data-jd-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.removeAttribute('role');
        var focusables = c.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        for (var k = 0; k < focusables.length; k++) focusables[k].setAttribute('tabindex', '-1');
        var ids = c.querySelectorAll('[id]');
        for (var d = 0; d < ids.length; d++) ids[d].removeAttribute('id');
        var imgs = c.querySelectorAll('img');
        for (var m = 0; m < imgs.length; m++) {
          imgs[m].setAttribute('loading', 'lazy');
          imgs[m].removeAttribute('fetchpriority');
        }
        return c;
      };
      this.originals.slice(-pv).forEach(function (el) { t.insertBefore(makeClone(el), first); });
      this.originals.slice(0, pv).forEach(function (el) { t.appendChild(makeClone(el)); });
    }

    this.measure();
    this.active = -1;
    this.setPos(this.loop ? this.pv + keep : 0, false);
  };

  /* ---------- Kretanje ---------- */

  Slider.prototype.go = function (dir) {
    if (!this.loop) {
      if (this.n > this.pv) this.setPos(this.pos + dir, true);
      return;
    }
    this.normalize();
    this.setPos(this.pos + dir, true);
  };

  Slider.prototype.goTo = function (i) {
    if (!this.loop) { this.setPos(i, true); return; }
    this.normalize();
    this.setPos(this.pv + i, true);
  };

  /* Korisnik je nešto uradio: autoplay kreće ispočetka, tačno jedan interval kasnije */
  Slider.prototype.user = function () {
    this.lastUser = Date.now();
    if (this.restartAutoplay) this.restartAutoplay();
  };

  /* ---------- Aktivni slajd, fade i tačkice ---------- */

  Slider.prototype.sync = function () {
    var idx = this.loop ? (((this.pos - this.pv) % this.n) + this.n) % this.n : this.pos;
    if (idx === this.active) return;
    this.active = idx;

    if (this.fade) {
      var kids = this.track.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].classList.toggle('is-active', parseInt(kids[i].getAttribute('data-jd-i'), 10) === idx);
      }
    }
    if (this.dots) {
      for (var d = 0; d < this.dots.length; d++) {
        this.dots[d].classList.toggle('is-active', d === idx);
        if (d === idx) this.dots[d].setAttribute('aria-current', 'true');
        else this.dots[d].removeAttribute('aria-current');
      }
    }
  };

  Slider.prototype.buildDots = function () {
    if (!this.dotsWrap || this.n < 2) return;
    var self = this;
    this.dots = [];
    this.dotsWrap.innerHTML = '';
    this.originals.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jd-slider__dot';
      b.setAttribute('aria-label', 'Slajd ' + (i + 1));
      b.addEventListener('click', function () { self.user(); self.goTo(i); });
      self.dotsWrap.appendChild(b);
      self.dots.push(b);
    });
  };

  /* ---------- Swipe / prevlačenje ---------- */

  Slider.prototype.bindDrag = function () {
    var self = this;
    var t = this.track;

    t.addEventListener('dragstart', function (e) { e.preventDefault(); });

    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (!self.loop && self.n <= self.pv) return;
      self.drag = {
        id: e.pointerId,
        x0: e.clientX,
        y0: e.clientY,
        startX: 0,
        axis: null,
        lastX: e.clientX,
        lastT: e.timeStamp,
        v: 0,
        startPos: self.pos
      };
    });

    t.addEventListener('pointermove', function (e) {
      var d = self.drag;
      if (!d || e.pointerId !== d.id) return;
      var dx = e.clientX - d.x0;
      var dy = e.clientY - d.y0;

      if (!d.axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { self.drag = null; return; }
        d.axis = 'x';
        clearTimeout(self.settleTimer);
        /* Zaustavi animaciju tamo gde je sada; polazni slajd je ciljni slajd
           prethodnog poteza, pa svaki novi swipe ide tačno jedan dalje */
        self.normalize();
        var cur = self.currentX();
        self.setX(cur, false);
        d.startX = self.x;
        d.x0 = e.clientX;
        d.startPos = self.pos;
        /* Miš: preuzmi pokazivač da prevlačenje radi i van slajdera.
           Dodir: browser ga već sam drži, pa ga ne diramo. */
        if (e.pointerType === 'mouse') {
          try { t.setPointerCapture(e.pointerId); } catch (err) {}
        }
        self.root.classList.add('is-dragging');
        dx = 0;
      }

      var x = d.startX + dx;
      var minX = -self.maxPos() * self.step;
      if (x > 0) x = self.loop ? 0 : x * 0.35;
      if (x < minX) x = self.loop ? minX : minX + (x - minX) * 0.35;
      self.setX(x, false);

      var dt = e.timeStamp - d.lastT;
      if (dt > 0) d.v = (e.clientX - d.lastX) / dt;
      d.lastX = e.clientX;
      d.lastT = e.timeStamp;
    });

    var end = function (e) {
      var d = self.drag;
      if (!d || e.pointerId !== d.id) return;
      self.drag = null;
      if (d.axis !== 'x') return;
      self.root.classList.remove('is-dragging');
      self.user();

      var cx = e.type === 'pointerup' ? e.clientX : d.lastX;
      var moved = cx - d.x0;
      var nearest = Math.round(-self.x / self.step);
      var flick = Math.abs(d.v) > 0.35 && (e.timeStamp - d.lastT) < 120;
      var target = d.startPos;
      if (Math.abs(moved) > self.step * 0.12 || flick) {
        target = d.startPos + (moved < 0 ? 1 : -1);
        if (moved < 0 && nearest > target) target = nearest;
        if (moved > 0 && nearest < target) target = nearest;
      }
      if (Math.abs(moved) > 6) {
        self.suppressClick = true;
        setTimeout(function () { self.suppressClick = false; }, 60);
      }
      self.setPos(target, true);
    };

    t.addEventListener('pointerup', end);
    t.addEventListener('pointercancel', end);
    t.addEventListener('lostpointercapture', function (e) {
      if (e.target !== t) return;
      if (self.drag && self.drag.id === e.pointerId && self.drag.axis === 'x') end(e);
    });

    t.addEventListener('click', function (e) {
      if (self.suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        self.suppressClick = false;
      }
    }, true);
  };

  /* Tastatura: kad fokus uđe u slajd koji nije vidljiv, pomeri slajder do njega */
  Slider.prototype.bindFocus = function () {
    var self = this;
    this.track.addEventListener('focusin', function (e) {
      var kids = toArray(self.track.children);
      var slide = e.target.closest ? e.target.closest('.jd-slider__track > *') : null;
      var k = kids.indexOf(slide);
      if (k < 0) return;
      self.viewport.scrollLeft = 0;
      if (k < self.pos) self.setPos(k, true);
      else if (k > self.pos + self.pv - 1) self.setPos(k - self.pv + 1, true);
    });
  };

  /* ---------- Autoplay ---------- */

  Slider.prototype.startAutoplay = function () {
    var self = this;
    var ms = this.autoplayMs;
    if (!ms || this.n < 2 || reduceMQ.matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var root = this.root;
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.hover = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.hover = false; });
    root.addEventListener('focusin', function () { self.hover = true; });
    root.addEventListener('focusout', function () { self.hover = false; });

    var tick = function () {
      if (!document.body.contains(root)) { clearInterval(self.autoTimer); return; }
      if (self.hover || self.drag || document.hidden) return;
      if (Date.now() - self.lastUser < ms - 100) return;
      var r = root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      self.go(1);
    };
    this.restartAutoplay = function () {
      clearInterval(self.autoTimer);
      self.autoTimer = setInterval(tick, ms);
    };
    this.restartAutoplay();
  };

  /* ---------- Inicijalizacija ---------- */

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-jd-slider]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-jd-ready')) continue;
      nodes[i].setAttribute('data-jd-ready', '1');
      sliders.push(new Slider(nodes[i]));
    }
  }

  function rebuildAll(onlyIfWidthChanged) {
    sliders.forEach(function (s) {
      if (!s.track || !document.body.contains(s.root)) return;
      if (onlyIfWidthChanged && Math.abs(s.viewport.clientWidth - s.width) < 2) return;
      s.build();
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { rebuildAll(true); }, 150);
  });

  var onMQ = function () { rebuildAll(false); };
  [mqTablet, mqDesktop].forEach(function (mq) {
    if (mq.addEventListener) mq.addEventListener('change', onMQ);
    else if (mq.addListener) mq.addListener(onMQ);
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    sliders.forEach(function (s) {
      var i = s.originals ? s.originals.indexOf(e.target) : -1;
      if (i >= 0) s.goTo(i);
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
